import { Button, Form, Modal } from 'shared/components/ui';
import React, { useState } from 'react';

import { WhatsApp, Send, Email, Payment } from '@mui/icons-material';
import api from '../../../../core/api/api';
import './NotificarModal.css';

const ACCIONES = [
  { id: 'confirmacionEmail', label: 'Confirmación de Turno (Email)', tipo: 'email', icon: <Email sx={{ fontSize: 18 }} />, color: '#3b82f6', descripcion: 'Envía el email de confirmación del turno al paciente.' },
  { id: 'cobroCopago', label: 'Cobro de Copago (Email)', tipo: 'email', icon: <Payment sx={{ fontSize: 18 }} />, color: '#8b5cf6', descripcion: 'Envía el email con el link de pago del copago al paciente.', requiereCopago: true },
  { id: 'confirmacionTurno', label: 'Notificación de Confirmación de Turno', tipo: 'whatsapp', icon: <WhatsApp sx={{ fontSize: 18 }} />, color: '#25d366', descripcion: 'Envía la notificación de confirmación del turno por WhatsApp.' },
  { id: 'turnoOtorgado', label: 'Turno Otorgado y Acceso al Portal', tipo: 'whatsapp', icon: <WhatsApp sx={{ fontSize: 18 }} />, color: '#25d366', descripcion: 'Notifica al paciente que su turno fue asignado, le pide verificar su email y le permite generar la clave de su portal.' },
  { id: 'cancelacion', label: 'Aviso de Cancelación', tipo: 'whatsapp', icon: <WhatsApp sx={{ fontSize: 18 }} />, color: '#ef4444', descripcion: 'Notifica al paciente la cancelación del turno por WhatsApp.' },
  { id: 'reprogramacion', label: 'Aviso de Reprogramación', tipo: 'whatsapp', icon: <WhatsApp sx={{ fontSize: 18 }} />, color: '#f59e0b', descripcion: 'Notifica al paciente que su turno debe reprogramarse por falta de confirmación.' },
];

const PLANTILLAS_WP = {
  confirmacionTurno: 'recordatorio_confirmar_turno',
  turnoOtorgado: 'aviso_turno_otorgado_v3',
  cancelacion: 'aviso_turno_cancelado',
  reprogramacion: 'aviso_turno_reprogramado',
};

const NotificarModal = ({ show, onHide, turno, onResult }) => {
  const [accion, setAccion] = useState('');
  const [email, setEmail] = useState('');
  const [telefono, setTelefono] = useState('');
  const [loading, setLoading] = useState(false);

  const telefonoPaciente = turno?.persona?.telCelular || '';
  const emailPaciente = turno?.persona?.mail || '';
  const nombrePaciente = turno?.persona ? `${turno.persona.apellido}, ${turno.persona.nombre}` : '';

  const handleOpen = () => {
    setAccion('');
    setEmail(emailPaciente);
    setTelefono(telefonoPaciente);
  };

  const handleEnviar = async () => {
    setLoading(true);
    try {
      if (accion === 'confirmacionEmail') {
        await api.get('/Email/SendEmailConfirmacionTurnoManual', { params: { idTurno: turno.idTurno, mail: email } });
        onResult({ message: `Email de confirmación enviado a ${email}`, type: 'success' });
      } else if (accion === 'cobroCopago') {
        await api.get('/Email/SendEmailCobroCopagoPorTurno', { params: { idTurno: turno.idTurno, mail: email } });
        onResult({ message: `Email de cobro de copago enviado a ${email}`, type: 'success' });
      } else {
        const plantilla = PLANTILLAS_WP[accion];
        await api.get('/Email/NotificarWhatsApp', { params: { idTurno: turno.idTurno, plantilla, telefono } });
        onResult({ message: `Notificación WhatsApp enviada (${ACCIONES.find(a => a.id === accion)?.label})`, type: 'success' });
      }
      onHide();
    } catch (err) {
      const msg = err.response?.data || 'Error al enviar la notificación.';
      onResult({ message: typeof msg === 'string' ? msg : 'Error al enviar la notificación.', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} onEnter={handleOpen} centered size="lg" className="notificar-modal" dialogClassName="notificar-modal">
      <Modal.Header closeButton>
        <Modal.Title>Notificar - Turno #{turno?.idTurno}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="notificar-paciente-info">
          <strong>{nombrePaciente}</strong>
          {emailPaciente && <span className="notificar-dato">📧 {emailPaciente}</span>}
          {telefonoPaciente && <span className="notificar-dato">📱 {telefonoPaciente}</span>}
        </div>

        <div className="notificar-acciones">
          {ACCIONES.filter(a => !a.requiereCopago || (turno?.copago && turno.copago > 0)).map(a => (
            <div
              key={a.id}
              className={`notificar-accion-item ${accion === a.id ? 'activa' : ''}`}
              onClick={() => setAccion(a.id)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && setAccion(a.id)}
              style={accion === a.id ? { borderColor: a.color, backgroundColor: `${a.color}10` } : {}}
            >
              <div className="notificar-accion-icon" style={accion === a.id ? { backgroundColor: `${a.color}20`, color: a.color } : {}}>
                {a.icon}
              </div>
              <div className="notificar-accion-content">
                <span className="notificar-accion-label">{a.label}</span>
                <span className="notificar-accion-desc">{a.descripcion}</span>
              </div>
              <span className="notificar-accion-badge" style={{ backgroundColor: `${a.color}15`, color: a.color }}>
                {a.tipo === 'whatsapp' ? 'WhatsApp' : 'Email'}
              </span>
            </div>
          ))}
        </div>

        {(accion === 'confirmacionEmail' || accion === 'cobroCopago') && (
          <Form.Group className="mt-3">
            <Form.Label>Email destino</Form.Label>
            <Form.Control
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email del paciente..."
            />
          </Form.Group>
        )}

        {accion && ACCIONES.find(a => a.id === accion)?.tipo === 'whatsapp' && (
          <Form.Group className="mt-3">
            <Form.Label>Teléfono destino</Form.Label>
            <Form.Control
              type="text"
              value={telefono}
              onChange={(e) => setTelefono(e.target.value)}
              placeholder="Ej: 5491155291681"
            />
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>Cancelar</Button>
        <Button
          variant="success"
          onClick={handleEnviar}
          disabled={loading || !accion || ((accion === 'confirmacionEmail' || accion === 'cobroCopago') && !email) || (ACCIONES.find(a => a.id === accion)?.tipo === 'whatsapp' && !telefono)}
        >
          <Send sx={{ fontSize: 16, mr: 0.5 }} />
          {loading ? 'Enviando...' : 'Enviar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NotificarModal;
